import classNames from "classnames";
import PropTypes from "prop-types";
import { Component as ReactComponent } from "react";
import Button from "./Button";
import { bsClass as setBsClass } from "./utils/bootstrapUtils";

const propTypes = {
  noCaret: PropTypes.bool,
  open: PropTypes.bool,
  title: PropTypes.string,
};

const defaultProps = {
  open: false,
  bsRole: "toggle",
};

class DropdownToggle extends ReactComponent {
  render() {
    const {
      noCaret,
      open,
      bsClass,
      className,
      children,
      isLoading = false,
      ...props
    } = this.props;

    delete props.bsRole;

    const Component = Button;
    const useCaret = !noCaret;

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    // FIXME: Should this really fall back to `title` as children?

    return (
      <Component
        {...props}
        role="button"
        className={classNames(className, bsClass)}
        aria-haspopup
        aria-expanded={open}
      >
        {children || props.title}
        {(isLoading || useCaret) && " "}
        {isLoading && (
          <span className="Select-loading" style={{ float: "right" }} />
        )}

        {!isLoading && useCaret && <span className="caret" />}
      </Component>
    );
  }
}

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;

export default setBsClass("dropdown-toggle", DropdownToggle);
